export default "__VITE_ASSET__D7F2KE0B__"